export default __webpack_public_path__ + "static/media/descricaoTodas.26f04d91.png";